<template>
    <div class="layout-body">
      <div class="layout-box">
        <Affix>
          <Row class="layout-box-top">
            <Col span="12" class="layout-box-tool">
              <Breadcrumb>
                <BreadcrumbItem>Exhibiting</BreadcrumbItem>
                <BreadcrumbItem>主页设置</BreadcrumbItem>
                <BreadcrumbItem>主页设置详情</BreadcrumbItem>
              </Breadcrumb>
              <div class="header-tool-title" style="margin:0;">{{exhibition.nameEn}}</div>
            </Col>
            <Col span="12" class="layout-box-tool f-tar">
              <Button style="margin-top:38px;" type="primary" @click="saveCustom()" :loading="loading">保存并提交</Button>
              <span style="display: inline-block;padding-left: 10px;"></span>
              <!-- <Button @click="back()">返回</Button> -->
            </Col>
          </Row>
        </Affix>
        <customCompanyComponentNew
          ref="customCompanyComponentNew"
          v-model="customData"
          v-if="show"
        ></customCompanyComponentNew>
      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import gSide from "@components/gSide/gSide";
import customCompanyComponentNew from "@components/custom-company-component-new/custom-company-component-new";

export default {
  name: "exhibition-template-brand",
  data() {
    return {
      loading: false,
      joinEx: null,
      customData: [
        {
          type: "Header",
          componentName: "customCompanyHeader",
          info: "顶部header",
          config: {}
        },
        {
          type: "Banner",
          componentName: "customCompanyBanner",
          info: "顶部banner",
          config: {
            type: 1, //类型Id
            isOpen: true, //是否开启
            coverType: "0", // 视频封面类型 0 截取 1 自定义
            cover: "", // 封面
            time: 2000, // 视频封面截取帧
            path: "", // 视频地址
            list: []
          }
        },
        // {
        //   type: "Exhibition",
        //   componentName: "customCompanyExhibition",
        //   info: "选择展会",
        //   config: {
        //     type: 8,
        //     isOpen: true,
        //     ExHall: "",
        //     BoothCode: "",
        //     BoothInfo: [],
        //     Categories: [],
        //     ExhibitionId: ""
        //   }
        // },
        {
          type: "Release",
          componentName: "customCompanyRelease",
          info: "商机",
          config: {
            type: 3,
            isOpen: true
          }
        },
        {
          type: "objective",
          componentName: "customCompanyObjective",
          info: "寻求代理",
          companyType: 4, // 1：服务商 2：工厂 3：加盟商 4：品牌商
          config: {
            type: 2,
            isOpen: true,
            title: "寻求代理",
            // "1:品牌商—授权渠道,2:品牌商—招募地区,3:工厂—服务范围,4:工厂—代工类型,5:服务商—擅长领域,6:服务商—服务地区,7:加盟商—店铺类型,8:加盟商—招募地区,9:其他文本",
            content: [
              {
                typeId: 1,
                key: "授权渠道",
                value: [],
                unit: "",
                active: false,
                input: ""
              },
              {
                typeId: 2,
                key: "招募地区",
                value: [],
                unit: "",
                active: false,
                input: ""
              }
            ]
          }
        },
        {
          type: "ProductGroup",
          componentName: "customCompanyProductGroup",
          info: "产品分组",
          config: {
            type: 7,
            isOpen: true,
            groupId: ""
          }
        },
        {
          type: "Cooperation",
          componentName: "customCompanyCooperation",
          info: "合作伙伴",
          config: {
            type: 4,
            isOpen: true,
            title: "合作伙伴"
          }
        },
        {
          type: "Brand",
          componentName: "customCompanyBrand",
          info: "旗下品牌",
          config: {
            type: 5,
            isOpen: true,
            title: "旗下品牌"
          }
        },
        {
          type: "Example",
          componentName: "customCompanyExample",
          info: "成功案例",
          config: {
            type: 6,
            isOpen: true,
            title: "成功案例"
          }
        }
      ],

      siderArr: [
        {
          title: "首页",
          icon: "icon-shouye11",
          router: "/exhibition/index/home",
          type: 1
        },
        // {
        //   title: "订单中心",
        //   icon: "icon-dingdanzhongxin",
        //   router: "/exhibition/index/order",
        //   type: 1
        // },
        // {
        //   title: "图集管理",
        //   icon: "icon-sucaiku1",
        //   router: "/exhibition/index/photo",
        //   type: 1
        // },
        {
          title: "参展",
          icon: "icon-diamonds",
          type: 2,
          children: [
            {
              title: "主页设置",
              router: "/exhibition/index/exinfo/exhibition-info"
            },
            // {
            //   title: "我的展位图",
            //   router: "/exhibition/index/exinfo/boothImg"
            // },
            {
              title: "Show Catalogue",
              router: "/exhibition/index/exinfo/catalogue"
            },
            {
              title: "Fascia (Shell Scheme Only)",
              router: "/exhibition/index/exinfo/fascia-board"
            },
            {
              title: "车证申请",
              router: "/exhibition/index/exinfo/carApply"
            }
          ]
        },
        // {
        //   title: "推广",
        //   icon: "icon-yijicaidanalituku_tuiguang",
        //   type: 2,
        //   children: [
        //     {
        //       title: "商机",
        //       router: "/exhibition/index/business"
        //     },
        //     {
        //       title: "商机",
        //       router: "/exhibition/index/release"
        //     },
        //     {
        //       title: "供需",
        //       router: "/exhibition/index/release-new"
        //     },
        //     {
        //       title: "动态",
        //       router: "/exhibition/index/moment"
        //     },
        //   ]
        // },
        {
          title: "My Cloud Booth",
          icon: "icon-guanli",
          type: 2,
          children: [
            {
              title: "产品",
              router: "/exhibition/index/product"
            },
            {
              title: "活动",
              router: "/exhibition/index/activity"
            },
            // {
            //   title: "人员",
            //   router: "/exhibition/index/companyAdmin"
            // },
            {
              title: "案例",
              router: "/exhibition/index/case"
            },
            {
              title: "品牌",
              router: "/exhibition/index/brand"
            },
            {
              title: "合作伙伴",
              router: "/exhibition/index/partner"
            },
            {
              title: "资质证书",
              router: "/exhibition/index/certificate"
            },
            {
              title: "素材库",
              router: "/exhibition/index/material"
            }
          ]
        },
        {
          title: "Exhibition Center",
          icon: "icon-peizhi1",
          type: 2,
          children: [
            {
              title: "公司信息",
              router: "/exhibition/index/companyInfo"
            },
            // {
            //   title: "管理员资料",
            //   router: "/exhibition/index/companyAdmin"
            // },
            {
              title: "产品分组",
              router: "/exhibition/index/proGroup/productlist"
            },
            // {
            //   title: "分享设置",
            //   router: "/exhibition/index/share"
            // },
            {
              title: "账户安全",
              router: "/exhibition/index/companyAccount"
            }
          ]
        }
      ],
      otherData: [],
      joinInfo: null, // 获取joinId
      exhibitionInfo: {},
      originType: "用户注册",
      show: false
    };
  },
  components: {
    gSide,
    customCompanyComponentNew,
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    })
  },
  async created() {
    this.bodyHeight = window.innerHeight ? window.innerHeight + "px" : "800px";
    this.init();
    if (this.$route.query && this.$route.query.origin === "2") {
      this.originType = "云展台";
    }
  },
  methods: {
    ...mapMutations({
      setExhibition: "loginModule/setExhibition",
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    ...mapActions({
      putJoinExhibitionInfo: "exhibitionModule/putJoinExhibitionInfo",
      joinExhibition: "exhibitionModule/joinExhibition",
      getByCompany: "exhibitionModule/getByCompany",
      getJoinById: "exhibitionModule/getJoinById"
    }),
    async init() {
      const query = this.$route.query;
      const bool = await this.getJoinById(query.editId);
      if (bool && bool.id) {
        if (bool.boothInfo && bool.boothInfo.indexOf("[") !== -1) {
          bool.boothInfo = JSON.parse(bool.boothInfo);
        }
        if (bool.compInfo && bool.compInfo.indexOf("{") !== -1) {
          bool.compInfo = JSON.parse(bool.compInfo);
        }
        if (bool.categories && bool.categories.indexOf("[") !== -1) {
          bool.categories = JSON.parse(bool.categories);
        }
        if (bool.shareInfo && bool.shareInfo.indexOf("{") !== -1) {
          bool.shareInfo = JSON.parse(bool.shareInfo);
        }
        if (bool.sharePoster && bool.sharePoster.indexOf("{") !== -1) {
          bool.sharePoster = JSON.parse(bool.sharePoster);
        }
        if (bool.exInfo && bool.exInfo.indexOf("{") !== -1) {
          bool.exInfo = JSON.parse(bool.exInfo);
        }
        if (bool.boothInfo && bool.boothInfo.indexOf("[") !== -1) {
          bool.boothInfo = JSON.parse(bool.boothInfo);
        }
        this.joinEx = bool;
      }
      // 初始化数据
      let tempInfo = {};
      if (this.joinEx.tempInfo) {
        tempInfo = JSON.parse(this.joinEx.tempInfo);
      }
      this.customData.map(c => {
        const ex = this.joinEx;
        tempInfo.forEach(v => {
          if (v.type === c.config.type) {
            if (v.type === 2) {
              c.config.title = v.title;
              c.config.isOpen = v.isOpen;
            }
            if (v.type === 2 && v.content) {
              c.config.isOpen = v.isOpen;
              c.config.content.forEach((z, i) => {
                v.content.forEach(w => {
                  if (w.key === z.key && w.typeId === z.typeId) {
                    c.config.content[i] = w;
                  }
                });
              });
            } else {
              c.config = v;
            }
          }
        });
        if (c.type === "Exhibition") {
          c.config.ExHall = ex.exHall;
          c.config.BoothCode = ex.boothCode;
          c.config.BoothInfo = ex.boothInfo;
          c.config.Categories = ex.categories;
          c.config.ExhibitionId = ex.exhibitionId;
        }
      });
      this.show = true;
    },
    async saveCustom() {
      this.$refs["customCompanyComponentNew"].saveCustom();
      setTimeout(() => {
        const req = this.transformData();
      }, 400);
    },
    async transformData() {
      if (!this.customData) return;
      let data = [];
      let copyData = JSON.parse(JSON.stringify(this.customData));
      copyData.forEach(c => {
        if (c.type !== "Header") {
          data.push(c.config);
        }
        if (c.type === "Exhibition") {
          this.exhibitionInfo = c.config;
        }
      });
      if (!this.exhibitionInfo.ExhibitionId && this.exhibitionInfo.isOpen) {
        this.$Message.error("请选择展会！");
        return;
      }
      this.otherData = data;
      this.editSelect();
    },
    async editSelect() {
      const query = this.$route.query;
      // 修改参展信息
      let formData = {
        Id: query.editId,
        SetValues: {
          TempId: "00000000-0000-0000-0000-000000000002",
          busMode: 0,
          // ExhibitionId: this.exhibitionInfo.ExhibitionId || "",
          ExhibitionId: this.exhibition.id,
          ExHall: this.exhibitionInfo.ExHall || "",
          BoothCode: this.exhibitionInfo.BoothCode || "",
          BoothArea: this.exhibitionInfo.BoothArea || 0,
          Categories: JSON.stringify(this.exhibitionInfo.Categories) || "",
          BoothInfo: JSON.stringify(this.exhibitionInfo.BoothInfo) || "",
          TempInfo: JSON.stringify(this.otherData)
        }
      };
      this.loading = true;

      setTimeout(() => {
        this.loading = false;
      }, 5000);

      let bool = await this.putJoinExhibitionInfo(formData);
      this.loading = false;

      if (bool.successed) {
        this.$Message.success("关联成功");
        this.init();
      } else {
        if (bool.errors && bool.errors[0]) {
          this.$Message.error(bool.errors[0].description);
          return;
        } else {
          this.$Message.error("关联失败，请重新尝试");
        }
      }
      this.setActiveIndex(-1);
      // this.back();
    },
    back() {
      if (this.$route.query && this.$route.query.origin === "2") {
        this.$router.push("/exhibition/index/exinfo/exhibition-info");
      } else {
        this.$router.push("/exhibition/index/home");
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.cloud {
  position: relative;
  .brand {
    line-height: 40px;
    background-color: #f5f5f5;
    padding: 0 14px;
  }
  &-control {
    position: absolute;
    left: 0;
    top: 0;
    width: 400px;
    height: 667px;
    border: 1px solid #e8e8e8;
    z-index: 2;
    .wrap {
      display: flex;
      padding: 10px;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
  &-template {
    background: url(http://dev.w.zhanshangxiu.net/assets/img/phone-brand.jpg) 0
      0 / contain no-repeat;
    width: 375px;
    height: 667px;
    margin: 50px auto;
    padding: 65px 0 10px;
    position: relative;
    z-index: 1;
    font-size: 14px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    &-box {
      width: calc(100% + 14px);
      height: 602px;
      overflow-y: scroll;
      overflow-x: hidden;
      .tmp {
        cursor: pointer;
      }
    }
  }
  &-set {
    position: absolute;
    right: 0;
    top: 0;
    height: 667px;
    width: 400px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
  }
  .item {
    box-sizing: border-box;
    flex: 0 0 32%;
    height: 30px;
    margin-bottom: 5px;
    border: 1px dashed #ebedf0;
    color: #646566;
    background: #f7f8fa;
    box-sizing: border-box;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 0;
    transition: all 1.2s;
    &:hover,
    &.active {
      background: #edf4ff;
      border-color: #3773da;
      color: #155bd4;
    }
    div {
      width: 100%;
      height: 100%;
    }
  }
}

.layout-box {
  padding-bottom: 20px;
  background: #fff;
  min-width: 1000px;
  &-top {
    box-shadow: 0px 0px 7px 0px rgba(146, 160, 185, 0.2);
    background: #fff;
  }
  &-tool {
    line-height: 54px;
    padding: 0 24px;
  }
}
.layout-body {
  height: 100%;
  background: #fff;
}
.layout-header-bar {
  display: flex;
  background: #002140;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.head-logo {
  // height: 64px;
  padding-top: 16px;
  padding-left: 19px;
}
.head-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-btn {
  font-size: 18px;
  color: #ededed;
  padding-right: 45px;
  display: inline-block;
  cursor: pointer;
}
</style>